import { first } from 'rxjs/operators'

import { Alias } from '@skinsoft/types'
import { AliasOfflineDataFetcher } from '@skinsoft/offline'
import { EntityDataStore } from '@skinsoft/entity-data-store'

export class AliasDataStore extends EntityDataStore<Alias> {
    public static getInstance() {
        if (!AliasDataStore.instance) {
            AliasDataStore.instance = new AliasDataStore()
        }

        return AliasDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$aliasDataStore = AliasDataStore.getInstance()
        Vue.prototype.$collaboratorDataStore = AliasDataStore.getInstance()
    }

    private static instance: AliasDataStore = null as any;

    constructor() {
        super('aliases', ['alias'])
    }


    public getCollaboratorByUserId(userId: string) {
        if (window.navigator.onLine) {
            return this.proxy.fetch(`${this.endpoint}/byUser/${userId}`)
                .pipe(first())
        } else {
            return (this.offlineDataFetcher as unknown as AliasOfflineDataFetcher).getByUser(userId)
        }
    }

    protected initializeDataFetcher() {
        // @ts-ignore
        this.offlineDataFetcher = new AliasOfflineDataFetcher("aliases")
    }
}


